import { UserBiqData } from "@app/schemas/biq";
import { createAction, props } from "@ngrx/store";

export const updateUserBiq = createAction(
  'User BIQ Updated',
  props<{ user: UserBiqData }>(),
);